import globalStyles from '../../styles/ButtonGradient.module.css';
import { FiUserPlus } from 'react-icons/fi';

const InviteAthleteButton = ({ onClick }) => {
  return (
    <button className={globalStyles.button} onClick={onClick || (() => console.log('Invite Athlete clicked'))}>
      <FiUserPlus className={globalStyles.icon} />
      Invite Athlete
    </button>
  );
};

export default InviteAthleteButton;
